import { Card, Header } from "semantic-ui-react";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import db from "astrid-firebase/src/db";
import agreementTypes from "astrid-firestore/src/api/agreements/constants/agreementTypes";

import Flex from "../../../../components/Flex/Flex";
import PrimaryButton from "../../../ui/components/Buttons/PrimaryButton";
import CollectionDataTable from "../../../ui/components/CollectionDataTable/CollectionDataTable";

import useAgreementColumns from "../../../agreements/hooks/useAgreementColumns";

export default function SuperAdminCloudAgreementsView() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const query = useMemo(() => db.collection("agreements").where("type", "==", agreementTypes.CLOUD), []);
	const columns = useAgreementColumns();

	return (
		<>
			<Flex gap={10} wrap style={{ marginBottom: 15 }}>
				<Header as="h2" style={{ margin: 0 }}>
					{t("cloudAgreements", "Cloud agreements")}
				</Header>

				<PrimaryButton as={Link} to="create">
					{t("newCloudAgreement", "New cloud agreement")}
				</PrimaryButton>
			</Flex>

			<Card fluid>
				<Card.Content>
					<CollectionDataTable
						query={query}
						columns={columns}
						onClick={({ id, firstParty }) =>
							navigate(`/producer/${firstParty.id}/finance/agreements/${id}`)
						}
						sortBy={{ id: "created", desc: true }}
					/>
				</Card.Content>
			</Card>
		</>
	);
}
